import React from "react";
import MapContainer from "../Components/map";

export default function Map() {
  return <MapContainer />;
}
